/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: React.Node,
  className?: string,
  component: React.ComponentType
};

type State = {
  active: false
};

const Button = styled('button')({
  background: 'none',
  border: 0
});

class ConcealedButton extends React.Component<Props, State> {
  props: Props;

  state: State = {
    active: false
  };

  static defaultProps = {
    className: undefined
  };

  handleClick = () => {
    this.setState({
      active: true
    });
  };

  render() {
    const { children, className, component: Component, ...restProps } = this.props;
    const { active } = this.state;

    if (active) {
      return (
        <Component className={className} {...restProps}>
          {children}
        </Component>
      );
    }

    return (
      <Button type="button" className={className} onClick={this.handleClick}>
        {children}
      </Button>
    );
  }
}

export default ConcealedButton;
